import { Injectable } from '@angular/core';
import { Permission } from '../../model/auth.model';
import { Storage } from '../storage/storage-service';

@Injectable({
  providedIn: 'root',
})
export class PermissionService {
  private permissions: Permission[] = [];

  constructor(private storage: Storage) {
    this.loadPermissions();
  }

  setPermissions(permissions: Permission[] | null | undefined): void {
    this.permissions = Array.isArray(permissions) ? permissions : [];
    this.storage.store('permissions', this.permissions);
  }

  loadPermissions(): void {
    const encryptedOrLegacyValue = this.storage.retrieve('permissions');
    if (Array.isArray(encryptedOrLegacyValue)) {
      this.permissions = encryptedOrLegacyValue;
      return;
    }

    // Migrate permissions saved by the previous plaintext implementation.
    const legacyValue = localStorage.getItem('permissions');
    if (!legacyValue) return;

    try {
      const permissions = JSON.parse(legacyValue);
      if (Array.isArray(permissions)) {
        this.permissions = permissions;
        this.storage.store('permissions', permissions);
      } else {
        this.clearPermissions();
      }
    } catch {
      this.clearPermissions();
    }
  }

  clearPermissions(): void {

    this.permissions = [];

    this.storage.remove('permissions');
  }

  hasPermission(code: string): boolean {
    return this.permissions.some((permission) =>
      this.normalise(permission.code) === this.normalise(code),
    );
  }

  hasAnyPermission(codes: string[]): boolean {
    return codes.some((code) => this.hasPermission(code));
  }

  hasModule(module: string): boolean {
    return this.permissions.some(
      (permission) => this.normalise(permission.module) === this.normalise(module),
    );
  }

   

  getPermissions(): readonly Permission[] {
    return [...this.permissions];
  }

  private normalise(value: string | null | undefined): string {
    return (value ?? '').trim().toLowerCase();
  }

}
